<template>
    <Card>
        <template v-slot:icon>
            <i class="fas fa-user-cog"/>
        </template>
        <template v-slot:title>
            {{ __('navigation.user_settings') }}
        </template>
        <template v-slot:description>
            {{ __('actions.manage_thing', {thing: __('user.settings')}) }}
        </template>

        <FormGroupNew :label="__('validation.attributes.salutation')"
                      :description="__('user.select_salutation')"
                      :error="form.errors.gender"
                      required>
            <RadioGroup :options="availableGenders"
                        v-model="form.gender"
                        inline
            />
        </FormGroupNew>

        <div class="row">
            <div class="col-md-6">
                <FormGroupNew :label="__('user.first_name')"
                              :description="__('user.enter_first_name')"
                              :error="form.errors.first_name"
                              required>
                    <input class="form-control" type="text" v-model="form.first_name">
                </FormGroupNew>
            </div>
            <div class="col-md-6">
                <FormGroupNew :label="__('user.last_name')"
                              :description="__('user.enter_last_name')"
                              :error="form.errors.last_name"
                              required>
                    <input class="form-control" type="text" v-model="form.last_name">
                </FormGroupNew>
            </div>
        </div>

        <DividerDotted class="mb-10"/>

        <div class="row">
            <div class="col-md-6">
                <FormGroupNew :label="__('general.phone')"
                              :description="__('user.provide_phone_number')"
                              :error="form.errors.phone"
                              required>
                    <input class="form-control" type="text" v-model="form.phone">
                </FormGroupNew>
            </div>
            <div class="col-md-6">
                <FormGroupNew :label="__('user.mobile')"
                              :description="__('user.provide_mobile_number')"
                              :error="form.errors.mobile"
                >
                    <input class="form-control" type="text" v-model="form.mobile">
                </FormGroupNew>
            </div>
        </div>

        <DividerDotted class="mb-10"/>

        <div class="row">
            <div class="col-md-6">
                <FormGroupNew class="user-select-none"
                              :label="__('user.newsletter')"
                              :error="form.errors.newsletter"
                              required>
                    <Checkbox v-model="form.newsletter">{{ __('actions.subscribe') }}</Checkbox>
                </FormGroupNew>
            </div>
        </div>

        <template v-slot:footer>
            <SaveAndEnableButton :disabled="!form.isDirty"
                                 @click="save"
            />
        </template>
    </Card>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import SaveAndEnableButton from "@components/Integrations/SaveAndEnableButton.vue";
import FormGroupNew from "@components/Form/FormGroupNew.vue";
import RadioGroup from "@components/Inputs/RadioGroup.vue";
import {Gender} from "@generated/gender";
import DividerDotted from "@components/Form/DividerDotted.vue";
import ClearableInput from "@components/Form/ClearableInput.vue";
import Checkbox from "@components/Form/Checkbox.vue";

export default {
    components: {Checkbox, ClearableInput, DividerDotted, RadioGroup, FormGroupNew, SaveAndEnableButton, Card},

    props: {
        user: {
            type: Object,
            required: true
        },
        registeredUsingEmail: Boolean
    },

    data() {
        return {
            form: this.$inertia.form({
                gender: this.user.gender,
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                phone: this.user.phone,
                mobile: this.user.mobile,
                newsletter: this.user.newsletter,
            })
        }
    },

    methods: {
        save() {
            this.form.patch(this.$route('user.update', [this.user.url_key]))
        }
    },

    computed: {
        availableGenders() {
            let available = {};
            for (let genderId of Object.values(Gender)) {
                if (genderId === Gender.DIVERS) {
                    available[__('general.none')] = genderId;
                } else {
                    available[__('user.salutations.' + genderId)] = genderId;
                }
            }
            return available;
        }
    }
}
</script>
